export const tr = {
    administration: 'Yönetim',
    'advanced-forecast-description':
        'Farklı gösterim bölgeleri ve anahtar sözcük grupları için yaklaşık harcamaların hesaplanması ve reklam geçişlerinin yaklaşık fiyatı.',
    'budget-forecast': 'Bütçe tahmini',
    'campaigns-of-client': 'Müşteri kampanyaları',
    create: 'Kampanya oluştur',
    'deals-list': 'Anlaşma listesi',
    'internal-ads-search': 'Dahili reklam arama',
    library: 'Arşivi',
    marketers: 'Pazarlamacılar',
    'my-campaigns': 'Kampanyalarım',
    'my-clients': 'Müşterilerim',
    products: 'Ürünler',
    recommendations: 'Öneriler',
    'recommendations-tooltip-content':
        'Direct, kampanyalarınız için günde birkaç kez önerileri yeniden hesaplar. Bu sefer hesaplanmış olanı inceleyin.',
    'recommendations-tooltip-header': 'Kampanya geliştirme önerileri',
    search: 'Arama',
    tools: 'Araçlar',
    'turbo-landing-constructor': 'Turbo Sayfa Sihirbazı',
    'word-stat': 'Sözcük seçimi',
    'word-stat-description':
        'Belirli bir sözcük grubunun veya anlam olarak benzer sorguların ayda kaç reklam veren tarafından arandığı bilgisi.'
};
